import validate from "/srv/artfield/node_modules/nuxt/dist/pages/runtime/validate.js";
import manifest_45route_45rule from "/srv/artfield/node_modules/nuxt/dist/app/middleware/manifest-route-rule.js";
export const globalMiddleware = [
  validate,
  manifest_45route_45rule
]
export const namedMiddleware = {
  "admin-auth": () => import("/srv/artfield/middleware/admin-auth.ts"),
  auth: () => import("/srv/artfield/middleware/auth.ts")
}